import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader, callApi } from "../Helpers";
import { MdCheck } from "react-icons/md";

export default function PatientRegistrationForm({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [fullname, setFullname] = useState("");
	const [dob, setDob] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [whatsAppNumber, setWhatsAppNumber] = useState("");
	const [physicalAddress, setPhysicalAddress] = useState("");
	const [nextKinFullname, setNextKinFullname] = useState("");
	const [nextKinRelationship, setNextKinRelationship] = useState("");
	const [registrationDate, setRegistrationDate] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setFullname("");
		setDob("");
		setPhone("");
		setEmail("");
		setWhatsAppNumber("");
		setPhysicalAddress("");
		setNextKinFullname("");
		setNextKinRelationship("");
		setRegistrationDate("");
	}

	async function create() {
		if(fullname.trim().length > 0) {
			setLoading(true);
			await callApi(
				'create-patient',
				{
					fullname,
					dob,
					phone,
					email,
					whatsAppNumber,
					physicalAddress,
					nextKinFullname,
					nextKinRelationship,
					registrationDate,
				}
			).then(response => {
				if(response.status === 1) {
					if(appContext.getAllPatients) {
						appContext.getAllPatients();
					}
					appContext.tellMessage("Successful");
					resetForm()
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid fullname");
		}
	}

	async function edit() {
		if(fullname.trim().length > 0) {
			setLoading(true);
			await callApi(
				'edit-patient',
				{
					uuid: data.uuid,
					fullname,
					dob,
					phone,
					email,
					whatsAppNumber,
					physicalAddress,
					nextKinFullname,
					nextKinRelationship,
					registrationDate,
				}
			).then(response => {
				if(response.status === 1) {
					if(appContext.getAllPatients) {
						appContext.getAllPatients();
					}
					appContext.tellMessage("Successful");
					
					if(callback) {
						callback();
					}
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Invalid fullname");
		}
	}

	useEffect(() => {
		if(data) {
			setFullname(data.fullname || "");
			setDob(data.dob || "");
			setPhone(data.phone || "");
			setEmail(data.email || "");
			setWhatsAppNumber(data.whatsAppNumber || "");
			setPhysicalAddress(data.physicalAddress || "");
			setNextKinFullname(data.nextKinFullname || "");
			setNextKinRelationship(data.nextKinRelationship || "");
			setRegistrationDate(data.registrationDate || "");
		}
	}, [ data ])

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Fullname</label>
					<input
						className="form-control"
						value={fullname}
						onChange={e => setFullname(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Date of Birth</label>
					<input
						type="date"
						className="form-control"
						value={dob}
						onChange={e => setDob(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Phone</label>
					<input
						className="form-control"
						value={phone}
						onChange={e => setPhone(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Email</label>
					<input
						type="email"
						className="form-control"
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">WhatsApp Number</label>
					<input
						className="form-control"
						value={whatsAppNumber}
						onChange={e => setWhatsAppNumber(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Registration Date</label>
					<input
						type="datetime-local"
						className="form-control"
						value={registrationDate}
						onChange={e => setRegistrationDate(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Physical Address</label>
					<textarea
						className="form-control"
						value={physicalAddress}
						onChange={e => setPhysicalAddress(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Next of Kin Fullname</label>
					<input
						className="form-control"
						value={nextKinFullname}
						onChange={e => setNextKinFullname(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Next of Kin Relationship</label>
					<input
						className="form-control"
						value={nextKinRelationship}
						onChange={e => setNextKinRelationship(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								appContext.activateDialog({
									message: `Edit this patient?`,
									onConfirm: edit,
								})
							} else {
								appContext.activateDialog({
									message: `Create new patient, ${fullname}?`,
									onConfirm: create,
								})
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

}